<template>
  <div class="header center-content">
    <div class="company">
      <div class="logo">
        <img src="../assets/img/logo.png" alt="久辉电力"/>
        <img src="../assets/img/company.png" alt=""/>
      </div>
      <div class="info">
        <div class="top">
          <div>
            <i class="iconfont icon-a-209dianhua-yuankuang"/>
            <span>13699414765</span>
          </div>
          <div>
            <i class="iconfont icon-youxiang"/>
            <span>576546387@qq.com</span>
          </div>
        </div>
        <div class="bottom">
          <div>
            <i class="iconfont icon-a-209dianhua-yuankuang"/>
            <span>028-64627660</span>
          </div>

          <div>
            <i class="iconfont icon-dizhi"/>
            <span>成都市高新区天府四街号2栋7层2号</span>
          </div>
        </div>
      </div>
    </div>


  </div>
  <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      :router="true"
  >
    <el-menu-item index="/home">首页</el-menu-item>
    <el-sub-menu index="2">
      <template #title>产品介绍</template>
      <el-menu-item index="/product_1">GIL和GIS在线监测</el-menu-item>
      <el-menu-item index="/product_2">变压器在线监测</el-menu-item>
      <el-menu-item index="/product_3">各种SF6气体装置</el-menu-item>
    </el-sub-menu>
    <el-menu-item index="" @click="showCompany()">联系我们</el-menu-item>
  </el-menu>


  <CompanyInfo :visible="showMe" @close="showMe = !showMe"></CompanyInfo>

  <el-tooltip
      class="box-item"
      effect="dark"
      content="回到顶部"
      placement="top"
  >
    <el-backtop :right="60" :bottom="120" :visibility-height="200"/>
  </el-tooltip>

  <el-tooltip
      class="box-item"
      effect="dark"
      content="联系我们"
      placement="top"
      ref="contact"
  >
    <div v-show="showContact" class="contact el-tooltip__trigger" @click="showMe = true">
      <i class="iconfont icon-lianxi"/>
    </div>
  </el-tooltip>

</template>

<script>
import CompanyInfo from "@/views/CompanyInfo";

export default {
  name: "Header",
  components: {
    CompanyInfo
  },
  data() {
    return {
      activeIndex: "/home",
      showMe: false,
      showContact: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.scrollHandle, true)
  },
  methods: {
    showCompany() {
      this.showMe = true
    },
    scrollHandle() {
      this.showContact = this.$utils.getScrollOffsetTop() >= 200;
    }
  }
}
</script>

<style lang="scss" scoped>
:root {
  --el-menu-active-color: $basic-color;
  --el-menu-hover-text-color: $basic-color;
}

.header {
  padding-top: 10px;
  display: flex;
  flex-direction: column;

  .company {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .iconfont {
      color: $basic-color;
      margin-right: 10px;
    }

    .logo {
      display: flex;
      align-items: center;

      img:nth-child(1) {
        width: 88px;
        height: 52px;
      }

      img:nth-child(2) {
        width: 460px;
        margin-left: 20px;
      }
    }

    .info {
      display: flex;

      > div {
        display: flex;
        flex-direction: column;

        div{
          margin-top: 10px;
        }

      }

      .top {


      }

      .bottom {
        margin-left: 20px;
      }
    }


  }
}

.el-menu {
  padding-left: 10% !important;
  margin-top: 20px;
  background-color: #f5f5f5;
  display: flex;
  flex: 1;
  border: none;


  .el-menu-item {
    margin-right: 10px;
    font-size: 20px;
  }

  .el-sub-menu {
    margin-right: 10px;
    font-size: 20px;
  }
}

::v-deep .el-sub-menu__title {
  font-size: 20px !important;
}

.el-menu--popup {
  .el-menu-item {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
}


.el-backtop {
  color: $basic-color !important;
  height: 50px;
  width: 50px;
}

.contact {
  position: fixed;
  bottom: 200px;
  right: 60px;
  color: $basic-color;
  z-index: 1000;
  background-color: #fff;

  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}

.contact:hover {
  cursor: pointer;
  background-color: #f2f6fc;
}

</style>